
export const showMessageAction = (message) => {
    return { type: 'SHOW_MESSAGE', message }
}

export const clearMessageAction = () => {
    return { type: 'CLEAR_MESSAGE' }
}